import { v4 as uuidv4 } from 'uuid';
import { ProductDescription } from '../../../../vtex-apps/store-components/ProductDescription/default';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function ProductDescriptionGroup() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'ProductDescriptionGroup',
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Descrição (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow(
				{
					mzTitle: 'MZ | Descrição do Produto',
					blockClass: 'product-description',
					colGap: 2,
				},
				[
					ProductDescription({
						blockClass: 'product-description',
						title: 'Descrição do Produto',
					}),
				],
			),
		],
	};
}

const variables =
	//font size for title,content and see more
	[
		{
			type: 'fontSize',
			list: [
				{ from: '--font-size-lg', to: '--prod-desc-1-title-fs', name: 'Title' },
				{ from: '--font-size-sm', to: '--prod-desc-1-content-fs', name: 'Content' },
				{ from: '--font-size-xs', to: '--prod-desc-1-see-more-fs', name: 'See More' },
			],
		},
		//font weight for title,content abd see more
		{
			type: 'fontWeight',
			list: [
				{ from: '--font-weight-700', to: '--prod-desc-1-title-fw', name: 'Title' },
				{ from: '--font-weight-500', to: '--prod-desc-1-content-fw', name: 'Content' },
				{ from: '--font-weight-500', to: '--prod-desc-1-see-more-fw', name: 'See More' },
			],
		},
		//font color for title,content abd see more
		{
			type: 'color',
			list: [
				//background color
				{ from: '--transparent', to: '--prod-desc-1-bg-color', name: 'Background' },
				{ from: '--text-color-1', to: '--prod-desc-1-title-color', name: 'Title' },
				{ from: '--text-color-1', to: '--prod-desc-1-content-color', name: 'Content' },
				{ from: '--text-color-1', to: '--prod-desc-1-see-more-color', name: 'See More' },
				//see more background color
				{
					from: '--neutral-color-low-medium',
					to: '--prod-desc-1-see-more-bg-color',
					name: 'See More Background',
				},
				//fade to color
				{ from: '--white', to: '--prod-desc-1-fade-to-color', name: 'See More Fade To' },
			],
		},
		//typography for title,content abd see more
		{
			type: 'typography',
			list: [
				{ from: '--main-font', to: '--prod-desc-1-title-typography', name: 'Title' },
				{ from: '--main-font', to: '--prod-desc-1-content-typography', name: 'Content' },
				{ from: '--main-font', to: '--prod-desc-1-see-more-typography', name: 'See More' },
			],
		},
		//spacing for see more
		{
			type: 'spacing',
			list: [
				{ from: '--spacing-xxxs', to: '--prod-desc-1-see-more-spacing-v', name: 'See More Vertical' },
				{ from: '--spacing-xxxs', to: '--prod-desc-1-see-more-spacing-h', name: 'See More Horizontal' },
				//title spacing
				{ from: '--spacing-xxxs', to: '--prod-desc-1-title-spacing-v', name: 'Title Spacing' },
			],
		},
		//border radius for see more
		{
			type: 'borderRadius',
			list: [{ from: '--border-radius-none', to: '--prod-desc-1-see-more-border-radius', name: 'See More' }],
		},
	];
